import { Card, CardActionArea, CardContent, CardMedia, Link, Typography } from '@mui/material';
import React from 'react'

const LandingCard = props => {
    return (
        <Card className={[props.classes.root, props.classes.card].join(' ')}>
            <Link href={props.link} component={CardActionArea} style={{ textDecoration: 'none', color: 'initial' }}>
                <CardMedia
                    className={props.classes.media}
                    image={props.image}
                    title={props.title}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {props.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {props.description}
                    </Typography>
                </CardContent>
            </Link>
        </Card>)
}

export default LandingCard;